
import { API_BASE } from "../auth/authClient";

﻿import React, { useState } from "react";


export default function OcrOhledaci({ onExtracted }) {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);

  async function spustitOcr() {
    if (!file) {
      alert("Vyber fotku / soubor ohledacího listu");
      return;
    }

    const fd = new FormData();
    fd.append("file", file); // ✅ MUSÍ být 'file' nebo 'image'

    setBusy(true);
    setLast(null);

    try {
      const res = await fetch(`${API_BASE}/api/ohledak-ocr`, {
        method: "POST",
        body: fd,
      });

      const json = await res.json();
      setLast(json);

      if (!json.ok) {
        alert(json.error || "OCR selhalo");
        return;
      }

      if (typeof onExtracted === "function") onExtracted(json.extracted);
    } catch (e) {
      alert("OCR: chyba připojení k serveru");
      console.error(e);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ border: "1px solid #333", borderRadius: 12, padding: 12 }}>
      <div style={{ fontWeight: 900, marginBottom: 8 }}>OCR – Ohledací list</div>

      <input
        type="file"
        accept="image/*,.pdf"
        onChange={(e) => setFile(e.target.files?.[0] || null)}
      />

      <div style={{ marginTop: 10 }}>
        <button
          onClick={spustitOcr}
          disabled={busy}
          style={{ padding: "10px 14px", borderRadius: 10, border: "1px solid #444", cursor: "pointer", fontWeight: 900 }}
        >
          {busy ? "Načítám..." : "Spustit OCR"}
        </button>
      </div>

      {last ? (
        <pre style={{ marginTop: 10, whiteSpace: "pre-wrap", fontSize: 12 }}>
          {JSON.stringify(last, null, 2)}
        </pre>
      ) : null}
    </div>
  );
}
